module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientCamerasTotal)))]), _vm._v(" cameras")])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('datepicker', {
    model: {
      value: (_vm.createdAfter),
      callback: function($$v) {
        _vm.createdAfter = $$v
      },
      expression: "createdAfter"
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('datepicker', {
    model: {
      value: (_vm.createdBefore),
      callback: function($$v) {
        _vm.createdBefore = $$v
      },
      expression: "createdBefore"
    }
  }), _vm._v(" "), _vm._m(2)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Find by"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.searchCameras($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "mac"
    }
  }, [_vm._v("MAC address")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manufacturer"
    }
  }, [_vm._v("Manufacturer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "model"
    }
  }, [_vm._v("Model")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "platform"
    }
  }, [_vm._v("Platform")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "platform_ver"
    }
  }, [_vm._v("Platform version")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "firmware_ver"
    }
  }, [_vm._v("Firmware version")])])])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.searchCameras
    }
  }, [_vm._v("Search")])])])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(!this.$store.state.clientCameras.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No devices found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.clientCameras), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mac))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.manufacturer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform_ver))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.firmware_ver))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Cameras")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("MAC")]), _vm._v(" "), _c('th', [_vm._v("Manufacturer")]), _vm._v(" "), _c('th', [_vm._v("Model")]), _vm._v(" "), _c('th', [_vm._v("Platform")]), _vm._v(" "), _c('th', [_vm._v("Platform version")]), _vm._v(" "), _c('th', [_vm._v("Firmware version")]), _vm._v(" "), _c('th', [_vm._v("Created at")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b232ed1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cameras/CameraList.vue
// module id = 352
// module chunks = 1